import React, { Component } from 'react'

class AnalysisMenu extends Component {
  public render = () => {
    return <div></div>
  }
}

export default AnalysisMenu
